import { InformationForBorrowingTrainContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingTrainContainer";

export function InformationForBorrowingTrainPage () {

    return(
        <InformationForBorrowingTrainContainer/>
    )
}




